module.exports = __webpack_public_path__ + "img/thumbnail_AmurLeopard_m_normal.51c484f4.png";